// extracted by mini-css-extract-plugin
export var chevron = "_2o-2";
export var chevronCollapsed = "_2o-3";
export var collapsibleHeader = "_2o-1";
export var container = "_2o-0";